import React, { useState } from "react";
import styles from "./styles.module.scss";
import ISelectProps from "./types/index";
import { InputFieldVW } from "../inputs";
import { Menu } from "../menus/default";
import arrowUp from "../../assets/svgs/keyboard_arrow_up-24px.svg";
import arrowDown from "../../assets/svgs/keyboard_arrow_down-24px.svg";

export const SelectVW = ({
  options,
  onChange,
  value,
  ...rest
}: ISelectProps) => {
  const [open, setOpen] = useState<boolean>(false);
  function updateOpen() {
    setOpen(!open);
  }
  function getInputValue(): string {
    const opt = options.find(o => o.value === value)!;
    return opt.label;
  }
  return (
    <div className={styles.root}>
      <div className={styles.select}>
        <InputFieldVW
          name={name}
          readOnly
          iconSrc={open ? arrowUp : arrowDown}
          iconClick={updateOpen}
          onClick={updateOpen}
          value={getInputValue}
          {...rest}
        />
      </div>
      {open && <Menu onSelectedChanged={onChange} items={options} />}
    </div>
  );
};
